import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import bindAll from 'lodash.bindall';
import LibraryComponent from '../../../components/library/library-no-modal';
import qs from "qs";
import DateTimePicker from 'react-datetime-picker';
import './react-datetime-picker.scss';
import ButtonComponent from "../../../components/button/button";
import styles from '../../lib/global.css';
import ModalManager from "../../components/modal/modal-manager";
import ScheduleModal from "./schedule-modal";
import Studentsgrades from "../../components/confirm-modal/students-grades";
import { updateLessonSchedule } from "../../api/course";
import { getLessonMembers } from "../../api/lesson";
import Message from "../../components/message/message";
import moment from 'moment';

class LessonScheduleList extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleItemSelect',
            'handleCorrect',
            'handleExperience'
        ]);
        this.query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    }

    handleItemSelect(item) {
        // this.props.history.push("/lesson?" + item.extensionId);
        Message.show(window.L("请点击卡片下方的三个按钮进行操作"))
    }

    handleExperience(item) {
        this.props.history.push("/lesson?" + item);
    }

    openScheduleModal(lesson) {
        ModalManager.open(ScheduleModal, {
            initDate: lesson.time ? moment(lesson.time, "YYYY-MM-DD hh:mm").toDate() : moment(new Date()).toDate(),
            closeAfterSubmit: true,
            onSet: (date) => {
                lesson.time = moment(date).format("YYYY-MM-DD HH:mm");
                updateLessonSchedule({
                    id: this.props.courseId,
                    clazz_id: this.props.clazzId,
                    schedules: [
                        {
                            lesson_id: lesson.id,
                            time: lesson.time
                        }
                    ]
                }).then(() => {
                    Message.show(window.L("teach.common.saveSuccess"))
                });
                this.forceUpdate();
            },
            onClose: () => { },
            type: 'single'
        });
    }

    async handleCorrect(lesson) {
        let members = await getLessonMembers({
            clazz_id: this.query.clazz_id,
            course_id: this.query.id,
            id: lesson.id,
        }, { quiet: true });
        ModalManager.open(Studentsgrades, {
            msg: members,
            closeAfterSubmit: true,
            lesson: lesson,
            ids: this.props,
            onClose: () => { }
        });
    }

    render() {
        const items = this.props.lessons.map(item => {
            const date = !!item.time && moment(item.time, "YYYY-MM-DD hh:mm");
            const locked = date && date > moment();
            const experienceUrl = `id=${item.id}&clazz_id=${this.props.clazzId}&course_id=${this.props.courseId}&experience=1`

            return {
                extensionId: `id=${item.id}&clazz_id=${this.props.clazzId}&course_id=${this.props.courseId}&check=1`,
                name: item.name,
                rawURL: window.config.staticURL + '/cover/lesson/' + item.id + '.png',
                //iconRawURL: "/static/appstore.png",
                //insetIconURL: item.studying ? require('./studying.png') : undefined,
                featured: true,
                //disabled: false,
                cornerText: locked ? window.L('teach.lesson.locked') : undefined,
                cornerStyle: locked ? { backgroundColor: '#969696' } : undefined,
                description:
                    <div onClick={e => { e.stopPropagation(); }} className={styles.antRow}>
                        <div onClick={() => this.openScheduleModal(item)}>
                            {item.time ? item.time : "时间未设置"}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', marginTop: 20 }}>
                            <ButtonComponent
                                onClick={() => this.handleExperience(experienceUrl)}
                            >
                                体验
                            </ButtonComponent>
                            <ButtonComponent
                                onClick={() => this.handleCorrect(item)}
                            >
                                批改
                            </ButtonComponent>
                            {/* {item.time || item.time === '' ? (
                                <ButtonComponent
                                    onClick={() => this.openScheduleModal(item)}
                                >
                                    编辑
                                </ButtonComponent>
                            ) : (null)} */}
                            <ButtonComponent
                                onClick={() => this.openScheduleModal(item)}
                            >
                                编辑
                            </ButtonComponent>
                        </div>
                    </div>,
            };
        });
        return (
            <React.Fragment>
                {/*<img style={{position: "absolute", zIndex:1, left:"18px", top:"21px"}} src={require('./new.png')} />*/}
                <LibraryComponent
                    data={items}
                    filterable={false}
                    id="CourseLibrary"
                    title="课程列表"
                    visible={true}
                    onItemSelected={this.handleItemSelect}
                />
            </React.Fragment>
        );
    }

}

LessonScheduleList.propTypes = {
    clazzId: PropTypes.number,
    courseId: PropTypes.number,
    lessons: PropTypes.arrayOf(PropTypes.object),
}

export default withRouter(LessonScheduleList);
